export enum ETenantId {
  CAREPLUS = 'CARE_PLUS',
  EINSTEIN = 'EINSTEIN'
}
